import React, { Component } from "react";

export default class BasePage extends Component {
  componentDidMount() {
    this._componentDidMount?.();
  }
  componentWillUnmount() {}
  render() {
    if (this.renderContent) {
      return this.renderContent();
    }
    return <div />;
  }
}
